import { VisitEncounterMode } from '@dreryk/egabinet-visit-frontend-api';

export const visitEncounterModeVisitor = (visitEncounterMode: VisitEncounterMode) => <ACCEPT>(type: {
   asOnSite: () => ACCEPT;
   asVideoConsultation: () => ACCEPT;
}) => {
   if (visitEncounterMode === 'VIDEO_CONSULTATION') {
      return type.asVideoConsultation();
   }

   return type.asOnSite();
};
